import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { PopupProps } from 'react-popup-manager';
import { AboutBoxModal, ClickableTextStyled, ContentStyled, StyledContainer } from './about-box.style';

import { env } from 'core/constants/env.constants';
import { Trans } from 'core/i18n';

const TRANSLATIONS = {
    title: 'app.header.options.about.modal.title',
    close: 'app.header.options.about.modal.close',
    version: 'app.header.options.about.modal.version',
    firstText: 'app.header.options.about.modal.first-text',
    secondText: 'app.header.options.about.modal.second-text',
    report: 'app.header.options.about.modal.report',
};

const AboutScreen: React.FC<PopupProps> = (props) => {
    const { isOpen, onClose } = props;
    const { t } = useTranslation();

    const handleDownload = () => {
        window.open(`/assets/${env.VITE_OTS_LICENSE_FILE_NAME}`, '_blank');
    };

    const version = env.APP_VERSION;

    return (
        <AboutBoxModal
            title={t(TRANSLATIONS.title)}
            isOpen={isOpen}
            onClose={onClose}
            onlyCloseAction
            cancelButtonText={t(TRANSLATIONS.close)}
        >
            <StyledContainer>
                <ContentStyled>{`${t(TRANSLATIONS.version)}: ${version}`}</ContentStyled>
                <ContentStyled variant="body2">
                    <Trans i18nKey={TRANSLATIONS.firstText} />
                </ContentStyled>
                <StyledContainer gap="8px">
                    <ContentStyled variant="body2">{t(TRANSLATIONS.secondText)}</ContentStyled>
                    <PocTypography variant="body1">
                        <ClickableTextStyled data-testid="aboutReport" onClick={handleDownload}>
                            {t(TRANSLATIONS.report)}
                        </ClickableTextStyled>
                    </PocTypography>
                </StyledContainer>
            </StyledContainer>
        </AboutBoxModal>
    );
};

export default AboutScreen;
